import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const EverythingInOnePlaceImage = () => {
  const data = useStaticQuery(graphql`
    query {
      everythingInOnePlaceImage: file(
        relativePath: { eq: "home/everythingInOnePlaceGraphic.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.everythingInOnePlaceImage.childImageSharp.fluid}
      alt="Everything In One Place Image"
    />
  )
}

export default EverythingInOnePlaceImage
